var _circle, _path, _rect, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFE5D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10156 9.85986V14.9998H5.9142V10.7335H14.2438V14.9998H15.097V9.85986H5.10156Z",
    fill: "#F09E72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.70203,
    y: 12.4402,
    width: 2.21445,
    height: 2.2754,
    fill: "#F09E72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.4041,
    y: 12.4402,
    width: 2.21445,
    height: 2.2754,
    fill: "#F09E72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2626 8.34424H6.89613L10.0224 6.57226L13.2626 8.34424Z",
    fill: "#F09E72",
    stroke: "#F09E72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubIcon);
export default __webpack_public_path__ + "static/media/HubIcon.5f84de96d4d991e34ec7cf494f0de50c.svg";
export { ForwardRef as ReactComponent };